const requireAll = r => {
  r.keys().forEach(r);
};

requireAll(require.context('!svg-sprite-loader?!../public/assets/img/', true, /\.svg$/));
